import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
/**
 * Keeps track of seed and handles pseudorandomness
 * Instance created in BaseRandomLayer class
 * Utilized for random preprocessing layers
 */
var RandomSeed = /*#__PURE__*/function () {
  function RandomSeed(seed) {
    _classCallCheck(this, RandomSeed);
    this.seed = seed;
  }
  _createClass(RandomSeed, [{
    key: "next",
    value: function next() {
      if (this.seed === undefined) {
        return undefined;
      }
      return this.seed++;
    }
  }]);
  return RandomSeed;
}();
RandomSeed.className = 'RandomSeed';
export { RandomSeed };